import type { FC, ReactNode } from 'react'

import { useRef } from 'react'

import { gsap, useGsap, prefersReducedMotion } from '@/lib/gsap'

const SLOTS = [
    { id: 'slot-one', active: true },
    { id: 'slot-two', active: true },
    { id: 'slot-three', active: false },
    { id: 'slot-four', active: false },
    { id: 'slot-five', active: false }
]

/* Two of five bars sit near full opacity and breathe on a yoyo loop; the
   remaining three stay parked at .4 so the pill reads as a capacity gauge. */
export const AvailabilityMeter: FC = (): ReactNode => {
    const scope = useRef<HTMLDivElement>(null)

    useGsap(() => {
        const root = scope.current

        if (!root || prefersReducedMotion()) {
            return
        }

        const bars = root.querySelectorAll<HTMLElement>('[data-slot-active]')

        if (bars.length === 0) {
            return
        }

        gsap.to(bars, {
            opacity: 0.42,
            duration: 1.05,
            repeat: -1,
            yoyo: true,
            stagger: 0.24,
            ease: 'sine.inOut'
        })
    }, scope, [])

    return (
        <div ref={scope} className='flex w-fit items-center gap-3'>
            <span
                role='img'
                aria-label='Two of five project slots are still open'
                className='flex items-center gap-[3px] rounded-full bg-paper/10 px-2.5 py-2'
            >
                {SLOTS.map((slot) => (
                    <span
                        key={slot.id}
                        data-slot-active={slot.active ? 'true' : undefined}
                        className='block h-[13px] w-[3px] rounded-full bg-paper'
                        style={{ opacity: slot.active ? 0.95 : 0.4 }}
                    />
                ))}
            </span>

            <span className='t-cond-soft text-[13px] leading-[1.3]'>
                <span className='text-paper'>
                    2 slots for
                </span>

                {' '}

                <span className='text-ash-soft'>
                    August &apos;26
                </span>
            </span>
        </div>
    )
}
